import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth-context";
import { ContrastProvider } from "./lib/contrast-context";
import { AppRouter } from "./router";
import { Toaster } from "./components/ui/sonner";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ContrastProvider>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </ContrastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
